<svg *ngIf="logo === 'mm-logo-dark'" xmlns="http://www.w3.org/2000/svg" viewBox="-177.1 295.9 250.1 250">
    <defs>
        <style>.st0 {
            fill: #334455;
        }

        .st1 {
            fill: url(#SVGID_1_);
        }

        .st2 {
            fill: #F8B941;
        }

        .st3 {
            fill: #FDCD4B;
        }

        .st4 {
            fill: #FBC345;
        }

        .st5 {
            fill: #F29E30;
        }

        .st6 {
            fill: #F7B039;
        }

        .st7 {
            fill: #ED9641;
        }

        .st8 {
            fill: #F4A735;
        }

        .st9 {
            fill: #F3B95C;
        }

        .st10 {
            fill: #FBC749;
        }
        </style>
    </defs>
    <g>
        <rect x="-177.1" y="295.8" class="st0" width="250.1" height="250.1"/>
        <g>
            <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="1.5689" y1="455.1951" x2="-89.8866"
                            y2="416.1689">
                <stop offset="0" style="stop-color:#FCC82B"/>
                <stop offset="0.4331" style="stop-color:#FABB27"/>
                <stop offset="1" style="stop-color:#F6A320"/>
            </linearGradient>
            <path class="st1" d="M34.4,502.7h-80.1c-1.4,0-2.3-1.3-1.8-2.6c3.2-8.9,6.5-17.9,9.8-26.8c-4.8-11.4-9.5-22.8-14.2-34.3
				c-4.7,11.4-9.5,22.8-14.2,34.3c3.2,8.9,6.5,17.9,9.8,26.8c0.5,1.3-0.5,2.6-1.8,2.6h-80.1c-0.9,0-1.6-0.9-1.3-1.8l52.7-158.2
				l0.9-2.8c0.4-1.3,2.2-1.3,2.7-0.1L-52,418l31.2-78.1c0.5-1.3,2.3-1.2,2.7,0.1l0.9,2.8L35.6,501C35.9,501.9,35.3,502.7,34.4,502.7
				z"/>
            <path class="st2" d="M11.5,428.7c-22.6,0-45.2-0.1-67.9-0.1c11.8-29.6,23.7-59.1,35.5-88.7c0.2-0.5,0.7-0.9,1.3-0.9
				c0.6,0,1.2,0.4,1.4,1C-8.2,369.6,1.7,399.1,11.5,428.7z"/>
            <path class="st3" d="M18.6,449.8c5.7,17.1,11.4,34.1,17.1,51.2c0,0.1,0.2,0.6-0.1,1.1c-0.4,0.6-1.1,0.7-1.1,0.7
				c-26.7,0-53.4,0-80.1,0c-0.1,0-0.9,0-1.5-0.6c-0.7-0.8-0.4-1.9-0.4-2c3.3-8.9,6.5-17.9,9.8-26.8L18.6,449.8z"/>
            <path class="st4" d="M33.7,428.7h-89.4c-0.3,0-0.5,0.3-0.4,0.5l30,72.9c0.1,0.3,0.5,0.3,0.7,0.1l60-71.6
				C35.2,429.9,34.7,428.7,33.7,428.7z"/>
            <path class="st5" d="M-123.8,453.3c-5.3,15.9-10.6,31.8-15.9,47.6c0,0.2-0.1,0.6,0.1,1.1c0.3,0.6,1.2,0.9,2.1,0.7
				c19.8,0,39.5,0,59.3,0c6.6,0,13.2,0,19.9,0c0.2,0,0.8,0,1.3-0.5c0.5-0.5,0.7-1.3,0.5-2.1c-3.3-8.9-6.5-17.9-9.8-26.8
				c-18.7-8.3-37.3-16.5-56-24.8C-122.6,449.7-123.2,451.3-123.8,453.3z"/>
            <path class="st6" d="M-115.6,428.7c22.4,0,44.8,0,67.2,0c0.3,0,0.5-0.3,0.4-0.5c-11.4-29-34-86.5-35.3-88.3
				c-0.7-0.9-1.3-0.9-1.3-0.9c-0.6,0-1.2,0.4-1.4,1C-95.9,369.5-105.7,399.1-115.6,428.7z"/>
            <path class="st7"
                  d="M-66.2,473.3l0.9,2.3c-3.6,9-7.2,18-10.8,27.1c-0.8,0-1.5,0-2.3,0C-74.4,492.9-70.3,483.1-66.2,473.3z"/>
            <path class="st8" d="M-137.7,428.6h89.4c0.3,0,0.5,0.3,0.4,0.5l-30,72.9c-0.1,0.3-0.5,0.3-0.7,0.1l-60-71.6
				C-139.2,429.8-138.7,428.6-137.7,428.6z"/>
            <path class="st9"
                  d="M-25.8,502.7c1,0,1.9,0,2.9,0c14-17,28.1-34.1,42.1-51.1c-0.2-0.6-0.4-1.2-0.6-1.9L-25.8,502.7z"/>
            <path class="st10" d="M-52.2,444.1"/>
        </g>
    </g>
</svg>
<svg *ngIf="logo === 'mm-logo'" xmlns="http://www.w3.org/2000/svg" viewBox="-75 175 10 500">
    <defs>
        <style>.st0 {
            fill: #334455;
        }

        .st1 {
            fill: url(#SVGID_1_);
        }

        .st2 {
            fill: #F8B941;
        }

        .st3 {
            fill: #FDCD4B;
        }

        .st4 {
            fill: #FBC345;
        }

        .st5 {
            fill: #F29E30;
        }

        .st6 {
            fill: #F7B039;
        }

        .st7 {
            fill: #ED9641;
        }

        .st8 {
            fill: #F4A735;
        }

        .st9 {
            fill: #F3B95C;
        }

        .st10 {
            fill: #FBC749;
        }
        </style>
    </defs>
    <g>
        <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="1.5689" y1="455.1951" x2="-89.8866"
                        y2="416.1689">
            <stop offset="0" style="stop-color:#FCC82B"/>
            <stop offset="0.4331" style="stop-color:#FABB27"/>
            <stop offset="1" style="stop-color:#F6A320"/>
        </linearGradient>
        <path class="st1" d="M34.4,502.7h-80.1c-1.4,0-2.3-1.3-1.8-2.6c3.2-8.9,6.5-17.9,9.8-26.8c-4.8-11.4-9.5-22.8-14.2-34.3
				c-4.7,11.4-9.5,22.8-14.2,34.3c3.2,8.9,6.5,17.9,9.8,26.8c0.5,1.3-0.5,2.6-1.8,2.6h-80.1c-0.9,0-1.6-0.9-1.3-1.8l52.7-158.2
				l0.9-2.8c0.4-1.3,2.2-1.3,2.7-0.1L-52,418l31.2-78.1c0.5-1.3,2.3-1.2,2.7,0.1l0.9,2.8L35.6,501C35.9,501.9,35.3,502.7,34.4,502.7
				z"/>
        <path class="st2" d="M11.5,428.7c-22.6,0-45.2-0.1-67.9-0.1c11.8-29.6,23.7-59.1,35.5-88.7c0.2-0.5,0.7-0.9,1.3-0.9
				c0.6,0,1.2,0.4,1.4,1C-8.2,369.6,1.7,399.1,11.5,428.7z"/>
        <path class="st3" d="M18.6,449.8c5.7,17.1,11.4,34.1,17.1,51.2c0,0.1,0.2,0.6-0.1,1.1c-0.4,0.6-1.1,0.7-1.1,0.7
				c-26.7,0-53.4,0-80.1,0c-0.1,0-0.9,0-1.5-0.6c-0.7-0.8-0.4-1.9-0.4-2c3.3-8.9,6.5-17.9,9.8-26.8L18.6,449.8z"/>
        <path class="st4" d="M33.7,428.7h-89.4c-0.3,0-0.5,0.3-0.4,0.5l30,72.9c0.1,0.3,0.5,0.3,0.7,0.1l60-71.6
				C35.2,429.9,34.7,428.7,33.7,428.7z"/>
        <path class="st5" d="M-123.8,453.3c-5.3,15.9-10.6,31.8-15.9,47.6c0,0.2-0.1,0.6,0.1,1.1c0.3,0.6,1.2,0.9,2.1,0.7
				c19.8,0,39.5,0,59.3,0c6.6,0,13.2,0,19.9,0c0.2,0,0.8,0,1.3-0.5c0.5-0.5,0.7-1.3,0.5-2.1c-3.3-8.9-6.5-17.9-9.8-26.8
				c-18.7-8.3-37.3-16.5-56-24.8C-122.6,449.7-123.2,451.3-123.8,453.3z"/>
        <path class="st6" d="M-115.6,428.7c22.4,0,44.8,0,67.2,0c0.3,0,0.5-0.3,0.4-0.5c-11.4-29-34-86.5-35.3-88.3
				c-0.7-0.9-1.3-0.9-1.3-0.9c-0.6,0-1.2,0.4-1.4,1C-95.9,369.5-105.7,399.1-115.6,428.7z"/>
        <path class="st7"
              d="M-66.2,473.3l0.9,2.3c-3.6,9-7.2,18-10.8,27.1c-0.8,0-1.5,0-2.3,0C-74.4,492.9-70.3,483.1-66.2,473.3z"/>
        <path class="st8" d="M-137.7,428.6h89.4c0.3,0,0.5,0.3,0.4,0.5l-30,72.9c-0.1,0.3-0.5,0.3-0.7,0.1l-60-71.6
				C-139.2,429.8-138.7,428.6-137.7,428.6z"/>
        <path class="st9"
              d="M-25.8,502.7c1,0,1.9,0,2.9,0c14-17,28.1-34.1,42.1-51.1c-0.2-0.6-0.4-1.2-0.6-1.9L-25.8,502.7z"/>
        <path class="st10" d="M-52.2,444.1"/>
    </g>
</svg>

<svg *ngIf="logo === 'tb-logo-dark'" viewBox="0 0 80 78" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="80" height="78" fill="white"/>
    <g clip-path="url(#clip0_12323_3969)">
        <path d="M36.3682 61.0296V26.8901H23V21H56.8V26.8901H43.3734V61.0296H36.3682Z" fill="#9301E6"/>
    </g>
    <defs>
        <clipPath id="clip0_12323_3969">
            <rect width="34" height="40" fill="white" transform="translate(23 21)"/>
        </clipPath>
    </defs>
</svg>
<svg *ngIf="logo === 'tb-logo'" viewBox="0 0 80 78" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_12323_3973)">
        <path d="M36.3682 61.0296V26.8901H23V21H56.8V26.8901H43.3734V61.0296H36.3682Z" fill="#9301E6"/>
    </g>
    <defs>
        <clipPath id="clip0_12323_3973">
            <rect width="34" height="40" fill="white" transform="translate(23 21)"/>
        </clipPath>
    </defs>
</svg>

<svg *ngIf="logo === 'slack-logo'" viewBox="-2.45 0 2452.5 2452.5" enable-background="new 0 0 2447.6 2452.5" xmlns="http://www.w3.org/2000/svg">
    <g clip-rule="evenodd" fill-rule="evenodd">
        <path d="m897.4 0c-135.3.1-244.8 109.9-244.7 245.2-.1 135.3 109.5 245.1 244.8 245.2h244.8v-245.1c.1-135.3-109.5-245.1-244.9-245.3.1 0 .1 0 0 0m0 654h-652.6c-135.3.1-244.9 109.9-244.8 245.2-.2 135.3 109.4 245.1 244.7 245.3h652.7c135.3-.1 244.9-109.9 244.8-245.2.1-135.4-109.5-245.2-244.8-245.3z" fill="#36c5f0"/>
        <path d="m2447.6 899.2c.1-135.3-109.5-245.1-244.8-245.2-135.3.1-244.9 109.9-244.8 245.2v245.3h244.8c135.3-.1 244.9-109.9 244.8-245.3zm-652.7 0v-654c.1-135.2-109.4-245-244.7-245.2-135.3.1-244.9 109.9-244.8 245.2v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.3z" fill="#2eb67d"/>
        <path d="m1550.1 2452.5c135.3-.1 244.9-109.9 244.8-245.2.1-135.3-109.5-245.1-244.8-245.2h-244.8v245.2c-.1 135.2 109.5 245 244.8 245.2zm0-654.1h652.7c135.3-.1 244.9-109.9 244.8-245.2.2-135.3-109.4-245.1-244.7-245.3h-652.7c-135.3.1-244.9 109.9-244.8 245.2-.1 135.4 109.4 245.2 244.7 245.3z" fill="#ecb22e"/>
        <path d="m0 1553.2c-.1 135.3 109.5 245.1 244.8 245.2 135.3-.1 244.9-109.9 244.8-245.2v-245.2h-244.8c-135.3.1-244.9 109.9-244.8 245.2zm652.7 0v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.2v-653.9c.2-135.3-109.4-245.1-244.7-245.3-135.4 0-244.9 109.8-244.8 245.1 0 0 0 .1 0 0" fill="#e01e5a"/>
    </g>
</svg>

